import React from 'react';
import { Link } from 'react-router-dom';
import { Star, BookOpen } from 'lucide-react';

/**
 * PillarHighlight Component - v3.5 Sidebar Block
 * 
 * Shows the pillar page for the current cluster in a sidebar.
 * Elevates cluster awareness for users and crawlers.
 */
export const PillarHighlight = ({ article, allArticles = [] }) => {
    if (!article?.category) return null;

    // Find pillars in this category
    const categoryPillars = allArticles.filter(a =>
        a.category === article.category &&
        (a.layoutType === 'pillar' || a.type === 'pillar') &&
        a.id !== article.id
    );

    // Also get the clusterPillarLink if available
    const mainPillar = article.clusterPillarLink;

    if (categoryPillars.length === 0 && !mainPillar) return null;

    return (
        <div className="glass rounded-xl p-6 border border-white/10">
            <h3 className="text-sm font-semibold text-muted-foreground uppercase tracking-wider mb-4">
                Essential Reading
            </h3>

            <ul className="space-y-1">
                {mainPillar && (
                    <li>
                        <Link
                            to={`/blog/${mainPillar.slug}`}
                            className="flex items-start gap-2 p-2 -mx-2 rounded-lg hover:bg-white/5 transition-colors group"
                        >
                            <div className="w-1.5 h-1.5 rounded-full bg-primary mt-2 flex-shrink-0" />
                            <span className="text-sm font-medium group-hover:text-primary transition-colors line-clamp-2">
                                {mainPillar.title}
                            </span>
                        </Link>
                    </li>
                )}
                {categoryPillars.slice(0, 3).map(pillar => (
                    <li key={pillar.id}>
                        <Link
                            to={pillar.canonicalPath || `/blog/${pillar.slug}`}
                            className="flex items-start gap-2 p-2 -mx-2 rounded-lg hover:bg-white/5 transition-colors group"
                        >
                            <div className="w-1.5 h-1.5 rounded-full bg-white/20 group-hover:bg-primary mt-2 flex-shrink-0 transition-colors" />
                            <span className="text-sm group-hover:text-primary transition-colors line-clamp-2">
                                {pillar.title}
                            </span>
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default PillarHighlight;
